require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-get-awesome-our-job-event-sponsors.json") })
        }
      }, "path---blog-get-awesome-our-job-event-sponsors");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-get-awesome-our-job-event-sponsors!./.cache/json/blog-get-awesome-our-job-event-sponsors.json
// module id = 831
// module chunks = 231608221292675